import { MapContainer, TileLayer, Marker, Circle } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import './index.css';

const ChaveLusaMap = ({ coordinates, explicit }) => {
    const customIcon = new L.Icon({
        iconUrl: '/static/react/chavelusa_pin.png',
        iconSize: [54, 54],
        iconAnchor: [27, 54],
        popupAnchor: [0, -54]
    });

    return (
        <MapContainer center={coordinates} zoom={13} scrollWheelZoom={false}>
            <TileLayer
                attribution='&copy; Esri'
                url="https://services.arcgisonline.com/ArcGIS/rest/services/Canvas/World_Light_Gray_Base/MapServer/tile/{z}/{y}/{x}"
            />
            {
                explicit ?
                    <Marker
                        position={coordinates}
                        icon={customIcon}
                    >
                    </Marker> :
                    <Circle
                        center={coordinates}
                        radius={1500}
                        fillOpacity={0.2}
                        fillColor="#00748D"
                        color="#00748D"
                    >
                    </Circle>
            }
        </MapContainer>
    );
}

export default ChaveLusaMap;